import React, { Component } from 'react';
import './App.css';
import Hero from './components/Hero/Hero';
import Navbar from './containers/NavBar/NavBar';

class App extends Component {
  render() {
    return (
      <div>
      <Hero/>
      <Navbar/>
     </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js